import { observer } from 'mobx-react-lite'

import { cx } from '@/Ship/Helpers/cssClass'
import type { Notify } from '@/Ship/Contracts/Notify'

import { formatDate } from '../Helpers/formatDate'
import { getUnitLabel } from '../Helpers/unitLabel'
import { formatVolume } from '../Helpers/volumeTotals'
import type { VehicleNeedsEditStore } from '../Stores/VehicleNeedsEditStore'
import type { VehicleNeedsViewStore } from '../Stores/VehicleNeedsViewStore'

import { ExecutorBlock, type ExecutorModalOpeners } from './ExecutorBlock'

import styles from './RequestFormTemplate.module.css'

interface VehicleNeedCardProps {
    mode: 'view' | 'edit'
    index: number
    vn: any
    viewStore: VehicleNeedsViewStore
    editStore: VehicleNeedsEditStore
    requestCancelled: boolean
    notify: Notify
    reload: () => void
    openers: ExecutorModalOpeners
}

const Fact = ({ label, value }: { label: string; value: unknown }) =>
    value === null || value === undefined || value === '' ? null : (
        <span>
            {label}: <b>{String(value)}</b>
        </span>
    )

/** Потреба у транспорті: заголовок, факти (операція, вантаж, відстань, період, маршрут) і виконавці */
export const VehicleNeedCard = observer(({ mode, index, vn, ...rest }: VehicleNeedCardProps) => {
    const period = [formatDate(vn.startDate), formatDate(vn.endDate)].filter(Boolean).join(' — ')
    const route = [vn.loadingPoint?.title, vn.unloadingPoint?.title].filter(Boolean).join(' → ')

    return (
        <section className={cx(styles, 'need')} aria-label={`Потреба ${index + 1}`}>
            <div className={cx(styles, 'needHead')}>
                <span className={cx(styles, 'needTitle')}>
                    Потреба {index + 1}
                    {vn.vehicleKind?.title ? ` · ${vn.vehicleKind.title}` : ''}
                </span>
                {vn.volume !== null && vn.volume !== undefined && !Number.isNaN(Number(vn.volume)) && (
                    <span className={cx(styles, 'chip')}>
                        Замовлено {formatVolume(Number(vn.volume))} {getUnitLabel(vn.unit)}
                    </span>
                )}
            </div>
            <div className={cx(styles, 'facts')}>
                <Fact label="Тех. операція" value={vn.techOperation?.title} />
                <Fact label="Вантаж" value={vn.cargo?.title} />
                <Fact label="Відстань, км" value={vn.distance} />
                <Fact label="Період" value={period} />
                <Fact label="Маршрут" value={route} />
                <Fact label="Примітка" value={vn.note} />
            </div>
            {(vn.executors ?? []).map((executor: any, i: number) => (
                <ExecutorBlock key={executor.uuid || i} mode={mode} vn={vn} executor={executor} {...rest} />
            ))}
        </section>
    )
})
